var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinOriginalWordmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1d1d1b}.cls-2{fill:#0076b2}.cls-3{fill:#fff}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "original-wordmark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.85 52.73h4.94v17.98h9.14v4.56H.85V52.73zM17.11 60h4.74v15.26h-4.74zm2.37-7.59a2.75 2.75 0 1 1-2.75 2.75 2.75 2.75 0 0 1 2.75-2.75M41.69 52.73h4.74V66.2l5.38-6.22h5.81l-6.22 7.07 6.09 8.22h-5.96l-5.04-7.55h-.06v7.55h-4.74V52.73zM24.48 60H29v2.09h.06a5 5 0 0 1 4.49-2.47c4.81 0 5.69 3.16 5.69 7.27v8.38h-4.7v-7.43c0-1.77 0-4-2.47-4s-2.85 1.93-2.85 3.92v7.55h-4.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.61 65.85a2.84 2.84 0 0 0-2.91-2.91 3.16 3.16 0 0 0-3.35 2.91zm4 6.77a8.35 8.35 0 0 1-6.48 3c-4.74 0-8.54-3.16-8.54-8.07s3.8-8.06 8.54-8.06c4.43 0 7.21 3.16 7.21 8.06v1.49h-11a3.54 3.54 0 0 0 3.57 3 4 4 0 0 0 3.38-1.87zM82.23 63.68A3.89 3.89 0 1 0 86 67.57a3.6 3.6 0 0 0-3.8-3.89m8.2 11.58H86v-2a6 6 0 0 1-4.71 2.4c-4.56 0-7.56-3.29-7.56-7.94 0-4.27 2.66-8.19 7-8.19a5.73 5.73 0 0 1 4.87 2h.06v-8.8h4.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.78 48H97.51a2.34 2.34 0 0 0-2.36 2.31v27.38A2.34 2.34 0 0 0 97.51 80h27.27a2.34 2.34 0 0 0 2.37-2.31V50.31a2.34 2.34 0 0 0-2.37-2.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.89 60h4.75v15.27h-4.75zm2.37-7.59a2.75 2.75 0 1 1-2.75 2.75 2.75 2.75 0 0 1 2.75-2.75M107.61 60h4.55v2.09h.06a5 5 0 0 1 4.49-2.47c4.81 0 5.69 3.16 5.69 7.27v8.38h-4.74v-7.43c0-1.77 0-4-2.47-4s-2.85 1.93-2.85 3.92v7.55h-4.74z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinOriginalWordmark);
export default __webpack_public_path__ + "static/media/LinkedinOriginalWordmark.a2779879aa70f2b184c220267bcffee5.svg";
export { ForwardRef as ReactComponent };